<jqxLoader #loader [imagePosition]="'top'" [width]="100" [height]="60" [text]="translate('Procesando')">
</jqxLoader>

<jqxWindow #form [theme]="environment.tema" [position]="getFormPos(form)" [width]="850" [height]="400" [zIndex]="50"
    [autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true" [resizable]="false" (onClose)="onClose()">
    <div class="formHeader" style="overflow-x: hidden;">
        {{translate('Vehiculos')}}
    </div>
    <div class="form" style="float:left; overflow-x: hidden;">
        <div style="float:left; width: 100%; height: 324px;">
            <jqxGrid #grid [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [source]="dataAdapter"
                [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="false"
                [selectionmode]="'checkbox'" [columns]="columns" [showrowlines]="false" [showcolumnlines]="true"
                [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
                [showaggregates]="true" [rowsheight]="30" [filterrowheight]="25" [columnsheight]="25" [enabletooltips]="true"
                [editable]="false" (onRowclick)="onRowClick($event)" (onBindingcomplete)="onBindingComplete()" [filtermode]="'excel'"
                (onRowdoubleclick)="onRowDoubleClick($event)">
            </jqxGrid>
        </div>
        <div style="float: left; margin-top: 8px;">
            <jqxButton style="float:left" [width]='100' [height]='26' [textImageRelation]='"imageBeforeText"'
                [textPosition]='"left"' [imgSrc]='"/assets/images/save.png"' [value]="translate('Guardar')"
                (onClick)="onGuardar()">
            </jqxButton>
        </div>

        <div style="float: left; margin-top: 8px;">
            <jqxButton style="float:left" [width]='100' [height]='26' [textImageRelation]='"imageBeforeText"'
                [textPosition]='"left"' [imgSrc]='"/assets/images/ver.png"' [value]="translate('Detalle')"
                (onClick)="onEditar()" [disabled]="movilSelect == null">
            </jqxButton>
        </div>
    </div>
</jqxWindow>

<div #formMovil></div>
